import { Link } from "@tanstack/react-router";
import { useState } from "react";
import { FeedbackModal } from "@/components/SiteFeedback";
import { Compass } from "lucide-react";

export function Footer() {
  const [contactOpen, setContactOpen] = useState(false);

  return (
    <>
      <footer className="py-8 mt-auto border-t border-border print:hidden">
        <div className="max-w-7xl mx-auto px-5 md:px-7">
          <div className="grid grid-cols-1 md:grid-cols-3 gap-6 items-center">
            {/* Brand */}
            <div className="flex items-center gap-3">
              <Compass className="h-[50px] w-[50px] text-primary" aria-hidden="true" />
              <span className="text-lg font-extrabold tracking-tight leading-none flex" style={{ fontFamily: "'Syne', sans-serif" }}>
                <span style={{ color: "#000000" }}>Ranch</span>
                <span style={{ color: "#000000" }}>Planner</span>
              </span>
            </div>

            {/* Legal + contact links */}
            <div className="flex items-center justify-center gap-6 text-sm text-muted-foreground">
              <Link to="/legal/terms" className="hover:text-foreground transition-colors">Terms</Link>
              <Link to="/legal/privacy" className="hover:text-foreground transition-colors">Privacy</Link>
              <button
                type="button"
                onClick={() => setContactOpen(true)}
                className="hover:text-foreground transition-colors"
              >
                Contact
              </button>
            </div>

          </div>
        </div>
      </footer>
      <FeedbackModal
        open={contactOpen}
        onClose={() => setContactOpen(false)}
        pageUrl={typeof window !== "undefined" ? window.location.pathname : null}
      />
    </>
  );
}
